import React from 'react';
import './Divider.css'; // Ensure the CSS file is correctly imported

const Divider = () => (
    <div className="divider"></div>
);

export default Divider;
